
import React from "react";
import {
    AccessDevicesTitle, AccessDevicesChip, ScheduleTitle
} from "../../../../../components/buttons/IconButtons";
import CustomGenericUserChip from "../../../../../components/CustomGenericUserChip";
import CustomGenericTittleIcon from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomDaySelector from "../../../../../components/CustomDaySelector";
import { t } from 'i18next';
import {getSelected} from "../Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const RenderExpandedRow = ({row}) => {

    return (
        <>
            <div className={"col-12"}>
                <CustomGenericTittleIcon Icon={ScheduleTitle} title={"schedule"} border={false}/>
            </div>
            <div className={"col-12 d-flex justify-content-center p-16px"}>
                <CustomDaySelector dayArray={getSelected(row)} setDayArray={() => {}} containerClasses={"p-16px"} readonly={true} />
            </div>
            <div className={"col-12 d-flex justify-content-center pb-3"}>
                <p className={"ibl-font-w-700"}>{t("from")}:</p>
            </div>
            <div className={"col-12 d-flex justify-content-center pb-3"}>
                <p>{row.schedule.openTime}</p>
            </div>
            <div className={"col-12 d-flex justify-content-center pb-3"}>
                <p className={"ibl-font-w-700"}>{t("to")}:</p>
            </div>
            <div className={"col-12 d-flex justify-content-center pb-3"}>
                <p>{row.schedule.closeTime}</p>
            </div>

            { row.devices?.length > 0 &&
                <div className={"col-12 mb-4"}>
                    <CustomGenericUserChip
                        list={row.devices}
                        title="access_devices"
                        Icon={AccessDevicesTitle}
                        IconAvatar={AccessDevicesChip}
                        getName={item => item.name}
                        keyExtractor={item => item.id}
                    />
                </div>
            }
        </>
    );
};

export default RenderExpandedRow
